// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/profile/menu-shape.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side_bar .side-bar-container .top_menubar {
  background-color: #5951db;
  width: fit-content;
  margin-top: 1px;
  border-radius: 0 34px 34px 0;
  transition: all 0.7s ease;
}

.side_bar .side-bar-container .top_menubar ul {
  padding-top: 1px;
}

.side_bar .side-bar-container .top_menubar ul li.home-side-gap{
 margin-top: 15px;
}

.side_bar .side-bar-container .top_menubar ul li {
  margin: 5px 0 0;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  padding: 5px 5px;
  display: flex;
  justify-content: center;
  flex: 0 0 auto;
  /* width: 150px;  */
}

.side_bar .side-bar-container .title {
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  position: absolute;
  opacity: 0;
  /* width: 500px; */
  width: auto;
  transition-delay: 0.2s;
}

.side_bar .side-bar-container .top_menubar ul li:hover .title {
  width: 171px;
}

.side_bar .side-bar-container .top_menubar ul li a {
  color: #fff;
  padding: 10px 10px;
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  font-size: 0.9375rem;
  border-radius: 0.375rem;
  width: 100%;
  text-align: left;
  transition: all 0.9s ease;
  text-decoration: none;
  overflow: visible;
  z-index: 999;
  justify-content: center;
}

.side_bar .side-bar-container .top_menubar ul li:hover .title {
  color: #5951db;
  opacity: 1;
  padding-left: 25px;
  font-weight: 700;
}

.animate__heartBeat {
  animation-name: heartBeat;
  animation-duration: 1.3s;
  animation-duration: calc(var(--animate-duration) * 1.3);
  animation-timing-function: ease-in-out;
}

@keyframes heartBeat {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.3);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.3);
  }

  70% {
    transform: scale(1);
  }
}

.without-hover {
  width: 9%;
  margin-right: 10px;
  flex: 0 1 auto;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.with-hover {
  width: 42%;
  /* margin-right: 10px; */
  flex: 0 1 auto;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.side_bar .side-bar-container .top_menubar ul li a:hover {
  border-radius: 0.375rem;
  width: 100%;
  text-align: left;
  transition: all 0.9s ease;
}

/* .side_bar .side-bar-container .top_menubar ul li:hover .with-hover {
flex: 0 1 auto;
opacity: 1;
transition: opacity 0.3s ease-in-out;
transform: scale(1.2);
display: block;
} */
.side_bar .side-bar-container .top_menubar ul li:hover:before {
  width: 300%;
  left: -13px;
}

/* .side_bar .side-bar-container .top_menubar ul li:hover  .without-hover{
flex: 0 1 auto;
opacity: 1;
display: none !important;
transition: opacity 0.3s ease-in-out;
transform: scale(1.2);
} */
.side_bar .side-bar-container .top_menubar ul li:before {
  content: "";
  position: absolute;
  height: 136px;
  width: 0%;
  /* background: url("/public/assets/offer-page/offer-p-bgg.webp"); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* background-color: red; */
  right: auto;
  /* padding: 30px 20px; */
  border-radius: 37px;
  background-size: cover;
  background-repeat: no-repeat;
  transition: all 0.7s ease;
  left: -10%;
  transform: rotate(180deg);
  z-index: 2;
}

.side_bar .side-bar-container .top_menubar ul li:hover:before {
  opacity: 1;
}

.side_bar .side-bar-container .top_menubar ul.mail_bottom {
  padding: 0;
}

.side_bar .side-bar-container .top_menubar ul.mail_bottom li.mail_menu {
  border-top: 2px solid #fff;
  position: relative;
  /* padding: 20px 12px;
  position: relative; */
  padding: 25px 12px;
  position: relative;
  margin-bottom: 40px;
}

.side_bar .side-bar-container .top_menubar ul.mail_bottom li.mail_menu::before {
  content: "";
  position: absolute;
  left: 0;
  background: #f6aa1e;
  height: 28%;
  width: 4px;
  transition: all 0.5s ease;
  opacity: 0;
  top: 30px;
}

.side_bar
  .side-bar-container
  .top_menubar
  ul.mail_bottom
  li.mail_menu:hover::before {
  opacity: 1;
}

.side_bar .side-bar-container {
  position: relative;
}

.hide_menubar {
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  left: -300px;
  width: 300px;
  z-index: 9999;
  height: 100%;
  position: fixed;
  top: 0;
  transition: 0.3s;
}

.mobile-overlay.active {
  opacity: 0.3;
  visibility: visible;
}

.aside-trigger:before {
  transform: rotate(45deg);
}

.aside-trigger:after {
  transform: rotate(-45deg);
}

.aside-trigger:after,
.aside-trigger:before {
  background-color: #333;
  content: " ";
  height: 23px;
  left: 15px;
  position: absolute;
  width: 2px;
}

.aside-trigger {
  cursor: pointer;
  height: 20px;
  position: absolute;
  right: 20px;
  top: 9px;
  width: 20px;
}

.mobile-overlay {
  height: 100%;
  position: fixed;
  top: 0;
  transition: 0.3s;
  background-color: #1e1e1e;
  opacity: 0;
  right: 0;
  visibility: hidden;
  width: 100%;
  z-index: 98;
}

.top_link.Log_out_hide {
  padding-left: 20px;
}

.mail_message {
  padding: 20px;
  font-family: "Poppins";
  font-weight: 500;
}

.hide_menubar li a {
  font-family: Poppins;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 10px;
  width: 100%;
}
.hide_menubar li a img {
  filter: invert(69%) sepia(85%) saturate(4389%) hue-rotate(233deg)
    brightness(88%) contrast(94%);
  width: 30px;
  margin-right: 10px;
}
.hide_menubar li a .submenu-icon {
  margin-left: 20px;
}
.side_bar .side-bar-container .hide_menubar::-webkit-scrollbar {
  display: none;
}

.side_bar .side-bar-container .mail_menu:hover .hide_menubar {
  left: 102%;
  opacity: 1;
}

.side_bar .side-bar-container .hide_menubar .hide_menu_container .top_link {
  padding: 14px 30px 11px;
}

.side_bar .side-bar-container .hide_menubar .hide_menu_container ul li {
  margin: 31px 0;
}

.side_bar .side-bar-container .hide_menubar .hide_menu_container ul li a {
  color: #00223f;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
  transition: all 0.5s ease;
}

.side_bar .side-bar-container .hide_menubar .hide_menu_container ul li a:hover {
  font-weight: 700;
}

.side_bar .side-bar-container .log_out {
  margin-top: 60px;
}

.main_fixed_bar {
  width: fit-content;
}

.side_bar .side-bar-container .log_out .logout_bottom {
  padding: 51px 28px 10px;
}

.side_bar .side-bar-container .hide_menubar .hide_menu_container .mail_link {
  border-top: 2px solid #cbcbcb;
}

.side_bar .side-bar-container .hide_menubar .hide_menu_container .mail_message {
  padding: 40px 30px 30px;
}

.side_bar
  .side-bar-container
  .hide_menubar
  .hide_menu_container
  .mail_message
  p {
  color: #00223f;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.side_bar
  .side-bar-container
  .hide_menubar
  .hide_menu_container
  .mail_message
  ul
  li {
  /* display: flex; */
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.side_bar
  .side-bar-container
  .hide_menubar
  .hide_menu_container
  .mail_message
  ul
  li
  a.profile_name {
  display: flex;
  align-items: center;
}

.side_bar
  .side-bar-container
  .hide_menubar
  .hide_menu_container
  .mail_message
  ul
  li
  a.profile_name
  .profile_img.online {
  position: relative;
  margin-right: 8px;
}

.side_bar
  .side-bar-container
  .hide_menubar
  .hide_menu_container
  .mail_message
  ul
  li
  a.profile_name
  .profile_img.online::before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #18bf15;
  right: -4px;
  top: 0px;
}

.side_bar
  .side-bar-container
  .hide_menubar
  .hide_menu_container
  .mail_message
  ul
  li
  a.profile_name
  .profile_img.ofline {
  position: relative;
  margin-right: 8px;
}

.side_bar
  .side-bar-container
  .hide_menubar
  .hide_menu_container
  .mail_message
  ul
  li
  a.profile_name
  .profile_img.ofline::before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #c2c2c2;
  right: -4px;
  top: 0px;
}

.side_bar
  .side-bar-container
  .hide_menubar
  .hide_menu_container
  .mail_message
  ul
  li
  a.message
  img {
  width: 14px;
}

.side_bar .side-bar-container .Log_out_hide {
  margin-top: 30px;
  padding-bottom: 0px !important;
}

.side_bar .side-bar-container .Log_out_hide ul li {
  margin-bottom: 13px !important;
}

/* newly added */
.hide_menubar .hide_menu_container .mail_link li svg {
  vertical-align: middle;
  font-size: 11px;
  margin-left: 8px;
  color: black;
}

/* .side_bar .side-bar-container .top_menubar ul li:hover  .with-hover{
filter: invert(80%) sepia(19%) saturate(2168%) hue-rotate(143deg) brightness(101%) contrast(99%);
} */
.side_bar .side-bar-container .top_menubar ul li:hover .with-hover {
  filter: invert(69%) sepia(85%) saturate(4389%) hue-rotate(233deg)
    brightness(88%) contrast(94%);
}

.hide_menubar.active {
  left: 0;
}


/* ============== */

.side_bar .side-bar-container 
.top_menubar ul .logout-side-bar img{
  width: 70%;
}

.side_bar .side-bar-container 
.top_menubar ul .logout-side-bar:hover a{
  justify-content: center;
}

.side_bar .side-bar-container .top_menubar ul li:hover a{
  justify-content: unset;
}

`, "",{"version":3,"sources":["webpack://./src/Components/side-bar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EAEE,yBAAyB;EAEzB,wBAAwB;EAExB,uDAAuD;EAEvD,sCAAsC;AACxC;;AA6BA;EACE;IAEE,mBAAmB;EACrB;;EAEA;IAEE,qBAAqB;EACvB;;EAEA;IAEE,mBAAmB;EACrB;;EAEA;IAEE,qBAAqB;EACvB;;EAEA;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,cAAc;EACd,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;;;GAMG;AACH;EACE,WAAW;EACX,WAAW;AACb;;AAEA;;;;;;GAMG;AACH;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mEAAmE;EACnE,yDAAqE;EACrE,2BAA2B;EAC3B,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,UAAU;EACV,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB;uBACqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,SAAS;AACX;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,MAAM;EACN,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE;iCAC+B;EAC/B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;EAME,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;EAQE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,QAAQ;AACV;;AAEA;;;;;;;;;EASE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,QAAQ;AACV;;AAEA;;;;;;;;;EASE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;GAEG;AACH;EACE;iCAC+B;AACjC;;AAEA;EACE,OAAO;AACT;;;AAGA,mBAAmB;;AAEnB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".side_bar .side-bar-container .top_menubar {\n  background-color: #5951db;\n  width: fit-content;\n  margin-top: 1px;\n  border-radius: 0 34px 34px 0;\n  transition: all 0.7s ease;\n}\n\n.side_bar .side-bar-container .top_menubar ul {\n  padding-top: 1px;\n}\n\n.side_bar .side-bar-container .top_menubar ul li.home-side-gap{\n margin-top: 15px;\n}\n\n.side_bar .side-bar-container .top_menubar ul li {\n  margin: 5px 0 0;\n  flex: 0 0 auto;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n  padding: 5px 5px;\n  display: flex;\n  justify-content: center;\n  flex: 0 0 auto;\n  /* width: 150px;  */\n}\n\n.side_bar .side-bar-container .title {\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 15px;\n  position: absolute;\n  opacity: 0;\n  /* width: 500px; */\n  width: auto;\n  transition-delay: 0.2s;\n}\n\n.side_bar .side-bar-container .top_menubar ul li:hover .title {\n  width: 171px;\n}\n\n.side_bar .side-bar-container .top_menubar ul li a {\n  color: #fff;\n  padding: 10px 10px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 0 1 auto;\n  font-size: 0.9375rem;\n  border-radius: 0.375rem;\n  width: 100%;\n  text-align: left;\n  transition: all 0.9s ease;\n  text-decoration: none;\n  overflow: visible;\n  z-index: 999;\n  justify-content: center;\n}\n\n.side_bar .side-bar-container .top_menubar ul li:hover .title {\n  color: #5951db;\n  opacity: 1;\n  padding-left: 25px;\n  font-weight: 700;\n}\n\n.animate__heartBeat {\n  -webkit-animation-name: heartBeat;\n  animation-name: heartBeat;\n  -webkit-animation-duration: 1.3s;\n  animation-duration: 1.3s;\n  -webkit-animation-duration: calc(var(--animate-duration) * 1.3);\n  animation-duration: calc(var(--animate-duration) * 1.3);\n  -webkit-animation-timing-function: ease-in-out;\n  animation-timing-function: ease-in-out;\n}\n\n@-webkit-keyframes heartBeat {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  14% {\n    -webkit-transform: scale(1.3);\n    transform: scale(1.3);\n  }\n\n  28% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  42% {\n    -webkit-transform: scale(1.3);\n    transform: scale(1.3);\n  }\n\n  70% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes heartBeat {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  14% {\n    -webkit-transform: scale(1.3);\n    transform: scale(1.3);\n  }\n\n  28% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  42% {\n    -webkit-transform: scale(1.3);\n    transform: scale(1.3);\n  }\n\n  70% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n.without-hover {\n  width: 9%;\n  margin-right: 10px;\n  flex: 0 1 auto;\n  opacity: 1;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.with-hover {\n  width: 42%;\n  /* margin-right: 10px; */\n  flex: 0 1 auto;\n  opacity: 1;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.side_bar .side-bar-container .top_menubar ul li a:hover {\n  border-radius: 0.375rem;\n  width: 100%;\n  text-align: left;\n  transition: all 0.9s ease;\n}\n\n/* .side_bar .side-bar-container .top_menubar ul li:hover .with-hover {\nflex: 0 1 auto;\nopacity: 1;\ntransition: opacity 0.3s ease-in-out;\ntransform: scale(1.2);\ndisplay: block;\n} */\n.side_bar .side-bar-container .top_menubar ul li:hover:before {\n  width: 300%;\n  left: -13px;\n}\n\n/* .side_bar .side-bar-container .top_menubar ul li:hover  .without-hover{\nflex: 0 1 auto;\nopacity: 1;\ndisplay: none !important;\ntransition: opacity 0.3s ease-in-out;\ntransform: scale(1.2);\n} */\n.side_bar .side-bar-container .top_menubar ul li:before {\n  content: \"\";\n  position: absolute;\n  height: 136px;\n  width: 0%;\n  /* background: url(\"/public/assets/offer-page/offer-p-bgg.webp\"); */\n  background-image: url(\"/public/assets/images/profile/menu-shape.png\");\n  /* background-color: red; */\n  right: auto;\n  /* padding: 30px 20px; */\n  border-radius: 37px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  transition: all 0.7s ease;\n  left: -10%;\n  transform: rotate(180deg);\n  z-index: 2;\n}\n\n.side_bar .side-bar-container .top_menubar ul li:hover:before {\n  opacity: 1;\n}\n\n.side_bar .side-bar-container .top_menubar ul.mail_bottom {\n  padding: 0;\n}\n\n.side_bar .side-bar-container .top_menubar ul.mail_bottom li.mail_menu {\n  border-top: 2px solid #fff;\n  position: relative;\n  /* padding: 20px 12px;\n  position: relative; */\n  padding: 25px 12px;\n  position: relative;\n  margin-bottom: 40px;\n}\n\n.side_bar .side-bar-container .top_menubar ul.mail_bottom li.mail_menu::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  background: #f6aa1e;\n  height: 28%;\n  width: 4px;\n  transition: all 0.5s ease;\n  opacity: 0;\n  top: 30px;\n}\n\n.side_bar\n  .side-bar-container\n  .top_menubar\n  ul.mail_bottom\n  li.mail_menu:hover::before {\n  opacity: 1;\n}\n\n.side_bar .side-bar-container {\n  position: relative;\n}\n\n.hide_menubar {\n  background-color: #fff;\n  overflow-x: hidden;\n  overflow-y: auto;\n  left: -300px;\n  width: 300px;\n  z-index: 9999;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  transition: 0.3s;\n}\n\n.mobile-overlay.active {\n  opacity: 0.3;\n  visibility: visible;\n}\n\n.aside-trigger:before {\n  transform: rotate(45deg);\n}\n\n.aside-trigger:after {\n  transform: rotate(-45deg);\n}\n\n.aside-trigger:after,\n.aside-trigger:before {\n  background-color: #333;\n  content: \" \";\n  height: 23px;\n  left: 15px;\n  position: absolute;\n  width: 2px;\n}\n\n.aside-trigger {\n  cursor: pointer;\n  height: 20px;\n  position: absolute;\n  right: 20px;\n  top: 9px;\n  width: 20px;\n}\n\n.mobile-overlay {\n  height: 100%;\n  position: fixed;\n  top: 0;\n  transition: 0.3s;\n  background-color: #1e1e1e;\n  opacity: 0;\n  right: 0;\n  visibility: hidden;\n  width: 100%;\n  z-index: 98;\n}\n\n.top_link.Log_out_hide {\n  padding-left: 20px;\n}\n\n.mail_message {\n  padding: 20px;\n  font-family: \"Poppins\";\n  font-weight: 500;\n}\n\n.hide_menubar li a {\n  font-family: Poppins;\n  color: #000;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 4px 10px;\n  width: 100%;\n}\n.hide_menubar li a img {\n  filter: invert(69%) sepia(85%) saturate(4389%) hue-rotate(233deg)\n    brightness(88%) contrast(94%);\n  width: 30px;\n  margin-right: 10px;\n}\n.hide_menubar li a .submenu-icon {\n  margin-left: 20px;\n}\n.side_bar .side-bar-container .hide_menubar::-webkit-scrollbar {\n  display: none;\n}\n\n.side_bar .side-bar-container .mail_menu:hover .hide_menubar {\n  left: 102%;\n  opacity: 1;\n}\n\n.side_bar .side-bar-container .hide_menubar .hide_menu_container .top_link {\n  padding: 14px 30px 11px;\n}\n\n.side_bar .side-bar-container .hide_menubar .hide_menu_container ul li {\n  margin: 31px 0;\n}\n\n.side_bar .side-bar-container .hide_menubar .hide_menu_container ul li a {\n  color: #00223f;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  white-space: nowrap;\n  transition: all 0.5s ease;\n}\n\n.side_bar .side-bar-container .hide_menubar .hide_menu_container ul li a:hover {\n  font-weight: 700;\n}\n\n.side_bar .side-bar-container .log_out {\n  margin-top: 60px;\n}\n\n.main_fixed_bar {\n  width: fit-content;\n}\n\n.side_bar .side-bar-container .log_out .logout_bottom {\n  padding: 51px 28px 10px;\n}\n\n.side_bar .side-bar-container .hide_menubar .hide_menu_container .mail_link {\n  border-top: 2px solid #cbcbcb;\n}\n\n.side_bar .side-bar-container .hide_menubar .hide_menu_container .mail_message {\n  padding: 40px 30px 30px;\n}\n\n.side_bar\n  .side-bar-container\n  .hide_menubar\n  .hide_menu_container\n  .mail_message\n  p {\n  color: #00223f;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.side_bar\n  .side-bar-container\n  .hide_menubar\n  .hide_menu_container\n  .mail_message\n  ul\n  li {\n  /* display: flex; */\n  justify-content: space-between;\n  align-items: center;\n  margin: 20px 0;\n}\n\n.side_bar\n  .side-bar-container\n  .hide_menubar\n  .hide_menu_container\n  .mail_message\n  ul\n  li\n  a.profile_name {\n  display: flex;\n  align-items: center;\n}\n\n.side_bar\n  .side-bar-container\n  .hide_menubar\n  .hide_menu_container\n  .mail_message\n  ul\n  li\n  a.profile_name\n  .profile_img.online {\n  position: relative;\n  margin-right: 8px;\n}\n\n.side_bar\n  .side-bar-container\n  .hide_menubar\n  .hide_menu_container\n  .mail_message\n  ul\n  li\n  a.profile_name\n  .profile_img.online::before {\n  content: \"\";\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #18bf15;\n  right: -4px;\n  top: 0px;\n}\n\n.side_bar\n  .side-bar-container\n  .hide_menubar\n  .hide_menu_container\n  .mail_message\n  ul\n  li\n  a.profile_name\n  .profile_img.ofline {\n  position: relative;\n  margin-right: 8px;\n}\n\n.side_bar\n  .side-bar-container\n  .hide_menubar\n  .hide_menu_container\n  .mail_message\n  ul\n  li\n  a.profile_name\n  .profile_img.ofline::before {\n  content: \"\";\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #c2c2c2;\n  right: -4px;\n  top: 0px;\n}\n\n.side_bar\n  .side-bar-container\n  .hide_menubar\n  .hide_menu_container\n  .mail_message\n  ul\n  li\n  a.message\n  img {\n  width: 14px;\n}\n\n.side_bar .side-bar-container .Log_out_hide {\n  margin-top: 30px;\n  padding-bottom: 0px !important;\n}\n\n.side_bar .side-bar-container .Log_out_hide ul li {\n  margin-bottom: 13px !important;\n}\n\n/* newly added */\n.hide_menubar .hide_menu_container .mail_link li svg {\n  vertical-align: middle;\n  font-size: 11px;\n  margin-left: 8px;\n  color: black;\n}\n\n/* .side_bar .side-bar-container .top_menubar ul li:hover  .with-hover{\nfilter: invert(80%) sepia(19%) saturate(2168%) hue-rotate(143deg) brightness(101%) contrast(99%);\n} */\n.side_bar .side-bar-container .top_menubar ul li:hover .with-hover {\n  filter: invert(69%) sepia(85%) saturate(4389%) hue-rotate(233deg)\n    brightness(88%) contrast(94%);\n}\n\n.hide_menubar.active {\n  left: 0;\n}\n\n\n/* ============== */\n\n.side_bar .side-bar-container \n.top_menubar ul .logout-side-bar img{\n  width: 70%;\n}\n\n.side_bar .side-bar-container \n.top_menubar ul .logout-side-bar:hover a{\n  justify-content: center;\n}\n\n.side_bar .side-bar-container .top_menubar ul li:hover a{\n  justify-content: unset;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
